import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-picker__date-container maz-flex-1 maz-flex maz-direction-column maz-space-around"
}
const _hoisted_2 = {
  key: "header-picker__year",
  class: "header-picker__year maz-dots-text"
}
const _hoisted_3 = {
  key: "header-picker__date",
  class: "header-picker__date maz-dots-text"
}
const _hoisted_4 = {
  key: "header-picker__hour",
  class: "header-picker__hour maz-flex maz-justify-end"
}
const _hoisted_5 = { class: "header-picker__dots-divider" }
const _hoisted_6 = {
  key: "header-picker__minute",
  class: "header-picker__minute"
}
const _hoisted_7 = {
  key: "header-picker__twelve",
  class: "header-picker__twelve maz-flex maz-justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, " close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MazBtn = _resolveComponent("MazBtn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header-picker maz-p-2 maz-text-white maz-flex", [`maz-bg-${_ctx.color}`]])
  }, [
    (_ctx.hasDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_TransitionGroup, { name: _ctx.transitionName }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.year], (y) => {
                  return (_openBlock(), _createElementBlock("span", { key: y }, _toDisplayString(y), 1))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["name"]),
          _createVNode(_TransitionGroup, { name: _ctx.transitionName }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.dateFormatted], (date) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: date,
                    class: "maz-dots-text"
                  }, _toDisplayString(_ctx.dateFormatted ? date : '-'), 1))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasTime && !_ctx.isTwelveFormat)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["header-picker__time maz-flex", [
        !_ctx.hasDate ? 'maz-flex-center': 'maz-align-end'
      ]])
        }, [
          (_ctx.timeFormatted.hour)
            ? (_openBlock(), _createBlock(_TransitionGroup, {
                key: 0,
                name: _ctx.transitionName
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.timeFormatted.hour], (hour) => {
                      return (_openBlock(), _createElementBlock("span", { key: hour }, _toDisplayString(hour), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.timeFormatted.hour ? ':' : '-'), 1),
          (_ctx.timeFormatted.minute)
            ? (_openBlock(), _createBlock(_TransitionGroup, {
                key: 1,
                name: _ctx.transitionName
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.timeFormatted.minute], (min) => {
                      return (_openBlock(), _createElementBlock("span", { key: min }, _toDisplayString(min), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["name"]))
            : _createCommentVNode("", true)
        ], 2))
      : (_ctx.hasTime)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["header-picker__time maz-flex", [
        !_ctx.hasDate ? 'maz-flex-center': 'maz-align-end'
      ]])
          }, [
            _createVNode(_TransitionGroup, { name: _ctx.transitionName }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.timeFormatted], (time, i) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `${time}-${i}`
                    }, _toDisplayString(_ctx.timeFormatted || '-'), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["name"])
          ], 2))
        : _createCommentVNode("", true),
    _createVNode(_component_MazBtn, {
      fab: "",
      size: "mini",
      "no-shadow": "",
      class: "header-picker__close",
      onClick: _ctx.close
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 2))
}